export default __webpack_public_path__ + "static/nieruchomosci-orlowo-9e7e24d85faf8ed97611428050d730c2.jpg";